import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet } from "react-router-dom";
import { useGetCurrentUserApi } from "../api/methods/use-get-current-user-api";
import { PageLoader } from "./page-loader";

export const ProtectedRoutes: React.FC = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { isLoading: isUserLoading } = useGetCurrentUserApi();

  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: window.location.pathname + window.location.search },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading || !isAuthenticated) {
    return <PageLoader />;
  }

  if (isUserLoading) {
    return <PageLoader />;
  }

  return <Outlet />;
};
